export default "__VITE_ASSET__7de551a4__"